var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEmptyTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 294,
    viewBox: "0 0 265 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 105,
    width: 94,
    height: 95,
    fill: "#E0E2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 200,
    width: 94,
    height: 94,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 105,
    width: 95,
    height: 95,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 200,
    width: 95,
    height: 94,
    fill: "#E0E2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9305 117.001C84.0597 116.976 82.2026 117.325 80.4686 118.028C78.7346 118.731 77.1588 119.774 75.8338 121.096C74.5089 122.417 73.4616 123.991 72.7536 125.724C72.0457 127.456 71.6913 129.313 71.7115 131.185C71.7594 139.108 77.8836 145.183 85.8265 145.185C93.7694 145.187 99.9206 139.083 99.9331 131.183C99.9456 123.282 93.7923 117.068 85.9305 117.001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.608 172.428C109.849 166.39 107.125 160.076 102.532 155.594C100.98 154.07 99.2138 152.78 97.2905 151.763C88.8128 147.308 80.3434 147.691 72.4047 153.083C71.2904 153.838 70.2376 154.679 69.2562 155.6C64.6365 159.949 62.3184 165.633 62.0853 172.426H62V181.75C62.3267 181.925 62.6534 182.098 62.9822 182.264C70.0435 185.837 77.8426 187.708 85.7558 187.726C93.669 187.745 101.477 185.911 108.555 182.37C108.921 182.187 109.284 181.999 109.643 181.804V172.436L109.608 172.428Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9305 212.001C84.0597 211.976 82.2026 212.325 80.4686 213.028C78.7346 213.731 77.1588 214.774 75.8338 216.096C74.5089 217.417 73.4616 218.991 72.7536 220.724C72.0457 222.456 71.6913 224.313 71.7115 226.185C71.7594 234.108 77.8836 240.183 85.8265 240.185C93.7694 240.187 99.9206 234.083 99.9331 226.183C99.9456 218.282 93.7923 212.068 85.9305 212.001Z",
    fill: "#E0E2E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.608 267.428C109.849 261.39 107.125 255.076 102.532 250.594C100.98 249.07 99.2138 247.78 97.2905 246.763C88.8128 242.308 80.3434 242.691 72.4047 248.083C71.2904 248.838 70.2376 249.679 69.2562 250.6C64.6365 254.949 62.3184 260.633 62.0853 267.426H62V276.75C62.3267 276.925 62.6534 277.098 62.9822 277.264C70.0435 280.837 77.8426 282.708 85.7558 282.726C93.669 282.745 101.477 280.911 108.555 277.37C108.921 277.187 109.284 276.999 109.643 276.804V267.436L109.608 267.428Z",
    fill: "#E0E2E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.931 212.001C179.06 211.976 177.203 212.325 175.469 213.028C173.735 213.731 172.159 214.774 170.834 216.096C169.509 217.417 168.462 218.991 167.754 220.724C167.046 222.456 166.691 224.313 166.712 226.185C166.759 234.108 172.884 240.183 180.826 240.185C188.769 240.187 194.921 234.083 194.933 226.183C194.946 218.282 188.792 212.068 180.931 212.001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.608 267.428C204.849 261.39 202.125 255.076 197.532 250.594C195.98 249.07 194.214 247.78 192.291 246.763C183.813 242.308 175.343 242.691 167.405 248.083C166.29 248.838 165.238 249.679 164.256 250.6C159.637 254.949 157.318 260.633 157.085 267.426H157V276.75C157.327 276.925 157.653 277.098 157.982 277.264C165.044 280.837 172.843 282.708 180.756 282.726C188.669 282.745 196.477 280.911 203.555 277.37C203.921 277.187 204.284 276.999 204.643 276.804V267.436L204.608 267.428Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8917 103L0 79.7801L134.318 0L265 79.8672L250.811 102.913L134.117 31.5898L13.8917 103Z",
    fill: "#E0E2E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.126 161.234C158.017 155.114 158.2 148.423 160.64 142.43C163.08 136.437 167.608 131.558 173.365 128.717C179.122 125.876 185.709 125.271 191.878 127.016C198.047 128.761 203.369 132.735 206.836 138.185C210.303 143.635 211.674 150.183 210.689 156.588C209.704 162.993 206.432 168.809 201.493 172.936C196.553 177.063 190.29 179.213 183.889 178.979C177.488 178.744 171.394 176.143 166.762 171.666L150.008 177.916L160.126 161.234Z",
    fill: "#E0E2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmptyTimeline);
export default __webpack_public_path__ + "static/media/logo_empty_timeline.66cb2a4753183cd2654c258e64a09fcb.svg";
export { ForwardRef as ReactComponent };